<template>
    <div style="text-align: left">
        <div class="list">角色管理</div>
        <div class="content">
            <div class="goods">
                <div class="search">
                    角色：<el-input style="width:200px" v-model.trim="role.roleName"></el-input>
                    <el-button type="primary" style="margin-left:10px" @click="getRoleList">搜 索</el-button>
                    <el-button @click="resetRoleList">重 置</el-button>
                </div>
                <br>
                <hr>
                <div style="margin-top: 20px">
                    <el-button type="primary" plain @click="dialogVisible = true">新增角色</el-button>
                    <!-- <el-button type="primary" plain>批量删除</el-button> -->
                </div>
            </div>
            <div class="role-list">
                <el-table :data="roleList" border style="width: 100%" :cell-style="{}" header-align="center">
                    <!-- <el-table-column type="selection" width="55" align="center">
                </el-table-column> -->
                    <el-table-column type="index" width="50" label="序号" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="roleName" width="300" label="角色名称" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="role" width="300" label="角色标识" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="操作" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="editorEcho(scope.row)">编辑权限</el-button>
                            <el-button type="text" size="small" @click="removeRole(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- <div class="block">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="queryList.pageNum" :page-size="queryList.pageSize"
                    layout="prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div> -->
        <!-- </div> -->


        <!-- 新增角色 -->
        <el-dialog :title="(roleAttr.id === '' ? '新增' : '编辑')" :visible.sync="dialogVisible" width="30%"
            :before-close="handleClose">
            <el-form :model="roleAttr" :rules="rules" ref="roleAttr" label-width="100px" class="demo-ruleForm">
                <el-form-item label="角色名称" prop="roleName">
                    <el-input v-model.trim="roleAttr.roleName" :disabled="(roleAttr.id === '' ? false : true)"></el-input>
                </el-form-item>
                <el-form-item label="角色标识" prop="role">
                    <el-input v-model.trim="roleAttr.role" :disabled="(roleAttr.id === '' ? false : true)"></el-input>
                </el-form-item>
                <el-form-item label="角色权限" prop="menu" v-if="roleAttr.id !== ''">
                    <el-tree :data="this.menu" show-checkbox node-key="id" ref="tree" highlight-current
                        :props="{ children: 'child', label: 'menuName' }" @check="currentChecked" accordion>
                    </el-tree>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="downDialog">取 消</el-button>
                <el-button v-if="roleAttr.id === ''" type="primary" @click="submitForm('roleAttr')">确 定</el-button>
                <el-button v-else type="primary" @click="submitForm('roleAttr')">编 辑</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import request from '../utils/request'
export default {
    data() {
        return {
            roleList: [],
            role: {
                isPage: false,
                roleName: ''
            },
            dialogVisible: false,
            roleAttr: {
                id: '',
                menu: [],
                role: '',
                roleName: ''
            },
            menu: [],
            rules: {
                roleName: [
                    { required: true, message: '请输入角色名称', trigger: 'blur' },
                ],
                role: [
                    { required: true, message: '请输入角色标识', trigger: 'blur' },
                ],
                menu: [
                    { required: true, message: '请选择权限', trigger: 'blur' },
                ],
            }
        }
    },
    methods: {
        // 获取角色列表
        async getRoleList() {
            const res = await request({
                url: 'admin/role/list',
                method: 'POST',
                data: this.role
            })
            //console.log(res);
            if (res.code === '200') {
                // this.$message.success(res.message);
                this.roleList = res.data && res.data.list
            } else {
                this.$message.error(res.message);
            }
        },
        // 弹窗关闭确认
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(() => {
                    done();
                    this.downDialog()
                })
                .catch(() => { });
        },
        // 表单校验
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.roleAttr.id === '') {
                        this.addRole()
                    } else {
                        this.editRole()
                    }
                    this.dialogVisible = false
                } else {
                    return false;
                }
            });
        },
        // 重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 重置新增表单
        resetAdd() {
            this.roleAttr.menu = []
            this.roleAttr.id = ''
            this.roleAttr.role = ''
            this.roleAttr.roleName = ''
        },
        // 关闭新增弹窗
        downDialog() {
            this.dialogVisible = false
            this.resetForm('roleAttr')
            this.resetAdd()
        },
        // 新增角色
        async addRole() {
            this.roleAttr.role = 'ROLE_' + this.roleAttr.role
            const res = await request({
                url: 'admin/role/add/role',
                method: "POST",
                data: this.roleAttr
            })
            //console.log(res);
            this.resetAdd()
            if (res.code === '200') {
                this.$message.success(res.message)
                this.resetRoleList()
            } else {
                this.$message.error(res.message)
            }
        },
        // 编辑权限弹窗
        editorEcho(val) {
            this.dialogVisible = true
            //console.log(val);
            this.getTree()
            this.getRoleAuthority(val.id)
            this.roleAttr.id = val.id
            this.roleAttr.role = val.role
            this.roleAttr.roleName = val.roleName
            //console.log('rrrrrrr',this.roleAttr);
        },
        // 重置角色列表
        resetRoleList() {
            this.role.roleName = ''
            this.getRoleList()
        },
        // 删除角色
        async removeRole(val) {
            const res = await request({
                url: `admin/role/delete/role?roleId=${val.id}`,
                method: 'GET'
            })
            //console.log(res);
            if (res.code === '200') {
                this.$message.success(res.message)
                this.getRoleList()
            } else {
                this.$message.error(res.message)
            }
        },
        // 权限树查询
        async getTree() {
            const res = await request({
                url: 'admin/menu/tree',
                method: 'POST'
            })
            //console.log(res);
            if (res.code === '200') {
                this.menu = res.data
            }
        },
        //当前选中的权限
        currentChecked() {
            // let childsids = this.$refs.tree.getCheckedKeys()

            let parentArr = this.$refs.tree.getHalfCheckedKeys();
            //获取子节点未全选时的父节点id
            let childArr = this.$refs.tree.getCheckedKeys();
            //获取所有选中节点的id
            let permissionParams = parentArr.concat(childArr)
            // {
            //     //获取全选中的id
            //     permissionids: parentArr.concat(childArr),
            //     //将两个数组进行拼接
            //     roleid: this.editRoleId
            // }
            // this.roleAttr.menu = childsids
            this.roleAttr.menu = permissionParams
            // //console.log('这是选中的节点的key数组', SelectedObj.checkedKeys)   // 这是选中的节点的key数组
            // //console.log('这是选中的节点数组', SelectedObj.checkedNodes)  // 这是选中的节点数组  

        },
        // 提交编辑权限
        async editRole() {
            const res = await request({
                url: 'admin/role/update/role',
                method: "POST",
                data: this.roleAttr
            })
            // //console.log(res);
            this.resetAdd()
            if (res.code === '200') {
                this.$message.success(res.message)
                this.resetRoleList()
            } else {
                this.$message.error(res.message)
            }
        },
        // 查寻该角色下的权限 
        async getRoleAuthority(id) {
            const res = await request({
                url: `admin/role/select/role?roleId=${id}`,
                method: 'GET'
            })
            // //console.log(res);
            if (res.code === '200') {
                this.roleAttr.menu = res.data
                this.$refs.tree.setCheckedKeys(res.data);
            } else {
                return
            }
        }
    },
    created() {
        this.getRoleList()
    }
}
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
    // display: flex;
    justify-content: space-between;


    .input-with-select {
        padding: 0;
    }
}

.search {
    line-height: 40px;
}

.role-list {
    overflow: auto;
    margin-top: 20px;
    min-height: 600px;
    background-color: #fff;
}
</style>